import { Button, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import KeikkaViewer from "src/components/keikka/keikkaViewer/KeikkaViewer";
import { CloseIcon } from "src/components/icons/ActionIcons";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

export default function KeikkaViewerModal({ open, onClose, keikkaId }) {
  const navigate = useNavigate();

  const handleNavigateToKeikkaKlik = () => {
    navigate(`/keikka/${keikkaId}`);
    // onClose();
  };
  return (
    <Dialog open={open && keikkaId > 0} onClose={onClose} maxWidth="md">
      <div className="spaceBetween">
        <DialogTitle>Tilaus</DialogTitle>
        <div style={{ display: "flex", gap: 10 }}>
          <Button variant="outlined" onClick={handleNavigateToKeikkaKlik}>
            Siirry tilaussivulle
          </Button>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      <DialogContent>
        <KeikkaViewer keikkaId={keikkaId} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
}

KeikkaViewerModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  keikkaId: PropTypes.number,
};
